import React from 'react';
import {SectionNotification} from 'wix-ui-tpa';
import {Error} from '@wix/wix-ui-icons-common/on-stage';
import {useTranslation, TFunction} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../../../domain/controllers/ControllerContext';
import s from './DeliveryError.scss';
import {CartModel} from '../../../../../../../domain/models/Cart/Cart.model';

export enum DeliveryErrorDataHook {
  Root = 'DeliveryError.Root',
  Message = 'DeliveryError.Error',
}

const getErrorMessage = (t: TFunction, cartModel: CartModel, isNonShippableCart: boolean) => {
  /* istanbul ignore next */
  if (cartModel.deliveryInfo) {
    const destination =
      cartModel.deliveryInfo.address.subdivisionFullname || cartModel.deliveryInfo.address.countryFullname;
    const message = isNonShippableCart ? 'cart.errors.cant_sell_to_country' : 'cart.errors.cant_ship_to_country';
    return t(message, {country: destination});
  }

  /* istanbul ignore next */
  return isNonShippableCart ? t('cart.errors.cant_sell_to_your_country') : t('cart.errors.cant_ship_to_your_country');
};

export const DeliveryError = () => {
  const {t} = useTranslation();
  const {isNonShippableCart, cartModel} = useControllerProps().cartStore;

  return (
    <div data-hook={DeliveryErrorDataHook.Root}>
      <dl>
        <dt>
          <SectionNotification type="error" data-hook={DeliveryErrorDataHook.Message} className={s.root}>
            <SectionNotification.Icon icon={<Error />} />
            <SectionNotification.Text>{getErrorMessage(t, cartModel, isNonShippableCart)}</SectionNotification.Text>
          </SectionNotification>
        </dt>
      </dl>
    </div>
  );
};
